import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import useUrlState from "@ahooksjs/use-url-state";
import tasksAPI from "../../../../services/tasks";
import scheduleAPI from "../../../../services/schedule";
import classesAPI from "../../../../services/classes";
import coursesAPI from "../../../../services/courses";
import slotsAPI from "../../../../services/slots";
import teachersAPI from "../../../../services/teachers";
import classroomsAPI from "../../../../services/classrooms";
import levelsAPI from "../../../../services/levels";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import { Dropdown } from "primereact/dropdown";
import UpdateScheduleModal from "./UpdateScheduleModal";
import { SelectButton } from "primereact/selectbutton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CLASSROOMS, PERMISSION_TRAINING_COURSES, PERMISSION_TRAINING_SCHEDULE, PERMISSION_TRAINING_SLOTS, PERMISSION_TRAINING_TASKS, PERMISSION_TRAINING_TEACHERS } from "../../../../permissions";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaTeacherAvatar from "../../components/MeaTeacherAvatar";


const ScheduleTableComponent = forwardRef((props, ref) => {
  const {
    selectedFields,
    filter,
    showFilterButton,
    showToolbar,
    showAddButton,
    showTotalSelectedElements,
    schoolId,
    trainingId,
  } = props;
  //
  const { hasPermission } = useAuthContext();
  const accessToken = "";
  //
  //
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  //
  const tableRef = useRef();
  const createModalRef = useRef();
  const updateModalRef = useRef();
  //
  const toast = useRef();
  //
  let selectedData = {
    slot: selectedFields?.slot ?? true,
    startHour: selectedFields?.startHour ?? true,
    endHour: selectedFields?.endHour ?? true,
    classe: selectedFields?.classe ?? true,
    course: selectedFields?.course ?? true,
    teacher: selectedFields?.teacher ?? true,
    classroom: selectedFields?.classroom ?? true,
    points: selectedFields?.points ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  //
  const [state, setState] = useUrlState({
    schedulePage: "1",
    scheduleFilter: JSON.stringify({
      slot_id: filter?.slot_id || "",
      level_id: filter?.level_id || "",
      classe_id: filter?.classe_id || "",
      course_id: filter?.course_id || "",
      teacher_id: filter?.teacher_id || "",
      classroom_id: filter?.classroom_id || "",
    }),
  });
  //
  const queryList = scheduleAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.scheduleFilter)
  );
  const [schedule, setSchedule] = useState(null);
  //
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const coursesQuery = coursesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const slotsQuery = slotsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const teachersQuery = teachersAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classroomsQuery = classroomsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  //
  const setFilter = (field, value) => {
    let currentFilter = state?.scheduleFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      schedulePage: 1,
      scheduleFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  const filterCombobox = (options, query, field) => {
    return (
      <Dropdown
        value={query?.data?.data?.find(
          (obj) => obj.id === JSON.parse(state.scheduleFilter)[field]
        )}
        options={query?.data?.data}
        optionLabel="name"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
          setFilter(field, e.value?.id || "");
        }}
        //itemTemplate={statusItemTemplate}
        placeholder="Séléctionner"
        className="p-column-filter"
        showClear
      />
    );
  };

  const normalizeCapacity = (capacity) => {
    if (capacity === undefined || capacity === null || capacity === "") {
      return null;
    }
    const parsedCapacity = Number(capacity);
    return Number.isFinite(parsedCapacity) && parsedCapacity > 0
      ? parsedCapacity
      : null;
  };

  const levelOptions = [
    { id: "", name: "Tous les niveaux" },
    ...(levelsQuery?.data?.data || []),
  ];
  //
  const startToolbarTemplate = (
    <div className="flex flex-row align-items-center flex-wrap gap-2">
      <Dropdown
        value={JSON.parse(state.scheduleFilter).level_id || ""}
        options={levelOptions}
        optionLabel="name"
        optionValue="id"
        onChange={(e) => {
          setFilter("level_id", e.value || "");
        }}
        placeholder="Filtrer par niveau"
        className="mr-2"
        style={{ minWidth: "220px" }}
        showClear
      />
      {showAddButton && (
        <>
          <MeaButton
            label="Programmer une séance"
            disabled={true}
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouvelle session"
            permission={PERMISSION_TRAINING_SCHEDULE.CREATE}
          />
          <MeaButton
            label="Générer le programme de la semaine"
            icon="pi pi-sun"
            size="small"
            className="p-button mr-2 action"
            outlined
            onClick={() => {
              confirmDialog({
                message:
                  "Voulez-vous générer le programme de la semaine pour cette formation?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                acceptLabel: "Oui",
                rejectLabel: "Non",
                defaultFocus: "reject",
                accept: () => {
                  tasksAPI
                    .GenerateSchedule(schoolId, trainingId, accessToken)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: "Succès",
                        life: 3000,
                      });
                      queryList?.refetch();
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de génération!",
                      });
                    });
                },
              });
            }}
            data-pr-tooltip="Generate"
            permission={PERMISSION_TRAINING_TASKS.GENERATE_SCHEDULE_ENTRIES}
          />
        </>
      )}
    </div>
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
      levelsQuery?.refetch();
    },
    getSelectedElements: () => {
      return tableRef.current.getSelectedElements();
    },
  }));
  //
  return (
    <>
      <ConfirmDialog />
      <Toast ref={toast} position="bottom-center" />
      <MeaDataTable
        ref={tableRef}
        query={queryList}
        serviceAPI={scheduleAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        accessToken={accessToken}
        names={{
          pagination: "schedule",
          singular: "séance",
          plural: "séances par semaine",
        }}
        startToolbarTemplate={startToolbarTemplate}
        showToolbar={showToolbar}
        showFilter={false}
        showFilterButton={showFilterButton}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_SCHEDULE.DELETE)}
        showTotalSelectedElements={showTotalSelectedElements}
        setPage={setPage}
        setPageSize={setPageSize}
        paginatorPosition="bottom"
        rowClassName={(rowData) => {
          const classCapacity = normalizeCapacity(rowData?.classe?.max_capacity);
          const totalStudents = Number(rowData?.classe_total_students);

          if (classCapacity !== null && Number.isFinite(totalStudents) && totalStudents > 0) {
            if (classCapacity === totalStudents) {
              return 'bg-green-100';
            } else if (classCapacity > totalStudents) {
              return 'bg-orange-100';
            } else if (classCapacity < totalStudents) {
              return 'bg-red-100';
            } else {
              return '';
            }
          }
          return '';
        }}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        {selectedData.classe && (
          <Column
            field="classe.name"
            header="Classe"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classes/" +
                  schedule?.classe?.id
                }
                permission={PERMISSION_TRAINING_CLASSES.GET}
              >
                {schedule?.classe?.name}
                {schedule?.classe_total_students && schedule?.classe_total_students > 0 &&  (
                  <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '4px' }}>
                    ( {schedule?.classe_total_students} élèves)
                  </span>
                ) || ""}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classesQuery, "classe_id")
            }
          ></Column>
        )}

        {selectedData.course && (
          <Column
            field="schedule_item.course.name"
            header="Matière"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/courses/" +
                  schedule?.course?.id
                }
                permission={PERMISSION_TRAINING_COURSES.GET}
              >
                {schedule?.course?.name}
                {normalizeCapacity(schedule?.classe?.max_capacity) !== null && (
                  <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '4px' }}>
                    ({normalizeCapacity(schedule?.classe?.max_capacity)} places)
                  </span>
                )}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, coursesQuery, "course_id")
            }
          ></Column>
        )}

        {selectedData.slot && (
          <Column
            header="Créneau"
            body={(schedule) => {
              return (
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/slots/" +
                    schedule?.slot_id
                  }
                  permission={PERMISSION_TRAINING_SLOTS.GET}
                >
                  {schedule?.slot?.name}
                  {schedule?.start_hour && schedule?.end_hour && (
                  <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '4px' }}>
                    ( {schedule?.start_hour} - {schedule?.end_hour})
                  </span>
                )}
                </MeaLink>
              );
            }}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, slotsQuery, "slot_id")
            }
          ></Column>
        )}
        
        {selectedData.teacher && (
          <Column
            header="Enseignant(e)"
            body={(schedule) => (
              <MeaTeacherAvatar teacher={schedule?.teacher} permission={PERMISSION_TRAINING_TEACHERS.GET} schoolId={schoolId} trainingId={trainingId} />
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) => {
              return (
                <Dropdown
                  value={JSON.parse(state.scheduleFilter)["teacher_id"] || ""}
                  options={teachersQuery?.data?.data?.map((item) => {
                    return {
                      label:
                        item.member?.name ||
                        item.member?.lastname + " " + item.member?.firstname,
                      value: item.id,
                    };
                  })}
                  onChange={(e) => {
                    options.filterApplyCallback(e.value);
                    setFilter("teacher_id", e.value || "");
                  }}
                  //itemTemplate={statusItemTemplate}
                  placeholder="Séléctionner"
                  className="p-column-filter"
                  showClear
                />
              );
            }}
          ></Column>
        )}
        {selectedData.classroom && (
          <Column
            field="classroom.name"
            header="Salle"
            body={(schedule) => (
              <MeaLink
                to={
                  "/school/" +
                  schoolId +
                  "/admin/trainings/" +
                  trainingId +
                  "/classrooms/" +
                  schedule?.classroom?.id
                }
                permission={PERMISSION_TRAINING_CLASSROOMS.GET}
              >
                {schedule?.classroom?.name}
                {schedule?.classroom?.capacity && (
                  <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '4px' }}>
                    ({schedule?.classroom?.capacity} places)
                  </span>
                )}
              </MeaLink>
            )}
            filter
            showFilterMenu={false}
            showClearButton={false}
            filterElement={(options) =>
              filterCombobox(options, classroomsQuery, "classroom_id")
            }
          ></Column>
        )}
        {selectedData.points && (
          <Column
            field="points"
            header="Points"
            body={(schedule) =>
              new Intl.NumberFormat("fr-FR", {
                maximumFractionDigits: 2,
              }).format(schedule?.points ?? 0)
            }
            headerStyle={{ width: "8%", minWidth: "5rem" }}
            bodyStyle={{ textAlign: "right" }}
          ></Column>
        )}
        {selectedData.edit && (
          <Column
            body={(schedule) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setSchedule(schedule);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_SCHEDULE.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateScheduleModal ref={updateModalRef} schedule={schedule} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
    </>
  );
});

export default ScheduleTableComponent;
